export default "__VITE_ASSET__6vyzA99M__"